<template>
  <div
    ref="virtualList"
    :class="[
      $style.searchResultContainer,
      {
        [$style.notificationsResult]: !isSearch && !isFeed,
        [$style.feedResult]: isFeed,
      },
    ]"
    @scroll="handleScroll"
  >
    <div
      v-if="(grouppedColumns.length === 0 && !isResultEmpty) || isFeed"
      :class="$style.groupHint"
    >
      {{ $t('table.moveColumnForGrouping') }}
    </div>
    <draggable
      :class="$style.draggableInput"
      :list="grouppedColumns"
      :group="{
        name: 'columns',
      }"
      :move="onMove"
      @change="move"
    >
      <div
        v-for="(element, idx) in grouppedColumns"
        :key="element.name"
      >
        <div :class="$style.grouppedItem">
          <div :class="$style.grouppedColumnName">
            {{ element.name }}
          </div>
          <button
            type="button"
            :class="$style.btnClose"
            aria-label="Close modal"
            @click="removeAt(idx)"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </draggable>

    <div
      v-if="!isPending && isResultEmpty && !isFeed"
      :class="$style.emptyResult"
    >
      {{ emptyResultString }}
    </div>
    <table
      v-else
      id="tableHead"
      :class="$style.table"
    >
      <thead :class="$style.head">
        <draggable
          :class="$style.draggableColumns"
          :list="reorderedColumns"
          :group="{
            name: 'columns',
            pull: 'clone',
            put: false,
          }"
          :sort="false"
          tag="tr"
          :move="onMove"
          @change="move"
        >
          <td
            v-for="column in reorderedColumns"
            :key="column.field"
            :class="$style.td"
            :style="{ width: column.width }"
            @dblclick="$emit('changeSort', column)"
          >
            <div :class="$style.tdInline">
              {{ column.name }}
            </div>
            <img
              src="@/assets/images/icons/table/sort-arrow.svg"
              :class="[
                $style.tdInline,
                $style.arrow,
                {
                  [$style.asc]: column.sort == 2,
                  [$style.hidden]: column.sort == 0,
                },
              ]"
              @click="$emit('changeSort', column)"
            >
            <div
              v-if="!isSearch && !isFeed"
              :class="$style.tdInline"
            >
              <img
                :id="'filterIcon' + column.field"
                src="@/assets/images/icons/navigation/filter.svg"
                :class="[$style.tdInline]"
                @click="$emit('filterClick', column)"
              >
              <div class="dropdown">
                <treeselect
                  :id="'columnFilter' + column.field"
                  v-model="selected[column.field]"
                  :multiple="true"
                  :options="column.filter"
                  :always-open="column.showFilter"
                  :normalizer="normalizer"
                  @input="filterGroupedData"
                />
              </div>
            </div>
          </td>
        </draggable>
      </thead>
    </table>
    <table
      v-if="!grouppedColumns.length"
      id="tableBody"
      :class="$style.resultTable"
    >
      <tr
        v-for="(item, index) in sortedData"
        :ref="`${tableName}-${item.id}`"
        :key="item.id.toString() + index.toString()"
        :class="tableBodyRowClassFn(item)"
        @click="selectRow(item)"
        @dblclick="openLogs(item)"
        @contextmenu.prevent="showMenu($event, item)"
      >
        <td
          v-for="column in reorderedColumns"
          :key="item.id + column.field"
          :class="[$style.td, { [$style.textCentr]: column.field === 'logName' }]"
          :style="{ width: column.width }"
        >
          <img
            v-if="isFilesSearch && column.field === 'path' && item.exists === 1"
            src="@/assets/images/icons/navigation/confirm.svg"
            :class="$style.icon"
          >
          <img
            v-if="isFilesSearch && column.field === 'path' && item.exists === 0"
            src="@/assets/images/icons/navigation/cancel.svg"
            :class="$style.icon"
          >

          <div v-if="column.field === 'date' && isFeed">
            <p
              v-if="item.isNew"
              :class="$style.new"
            >
              NEW
            </p>
            {{ getDataField(item, column.field) }}
          </div>

          <div v-else-if="column.field === 'details'">
            <log-details :data="item" />
          </div>
          <div v-else>
            <img
              v-if="column.field === 'logName'"
              :src="getIcon(item.logId).img"
              :class="$style.logIcon"
              :title="getIcon(item.logId).name"
            >
            <div v-else>
              {{ getDataField(item, column.field) }}
            </div>
          </div>
        </td>
      </tr>
    </table>

    <div v-else>
      <grouped-table
        :data="sortedGroupData"
        :columns="reorderedColumns"
        :depth="0"
        :padding="0"
        :selected-row="selectedRowId"
        :is-search="isSearch"
        :is-feed="isFeed"
        :is-files-search="isFilesSearch"
        @changeSelectedRow="selectRow"
        @openLogs="openLogs"
        @showMenu="showMenu"
      />
    </div>
    <loader
      v-if="isPending && !sortedData.length"
      :class="$style.loader"
    />
    <div
      v-if="isPending && sortedData.length"
      :class="$style.allData"
    >
      {{ $t('common.download') }}
    </div>
    <div
      v-if="isFetch && !isResultEmpty"
      :class="$style.allData"
    >
      {{ $t('common.apply') }}
    </div>

    <additional-list
      v-if="isSearch && !isFilesSearch && selectedRow"
      :list="getAdditionalList(selectedRow.logId, selectedRow)"
      :search="true"
      :found="foundSubstr"
      :search-string-length="searchString.length"
    />
    <additional-list
      v-if="!isSearch && !isFilesSearch && selectedRow && !isFeed"
      :list="additionalListNotifications"
    />
    <context-menu
      v-show="isMenuVisible"
      id="notificationsContextmenu"
      :notification-id="targetId"
      :user-id="targetUser"
      :mouse-x="mouseX"
      :mouse-y="mouseY"
      :event-id="targetEvent"
      :log="selectedLog"
      :is-target-checked="isTargetChecked"
      :is-target-event="isTargetEvent"
      :target-time="targetTime"
      :is-all-logs="true"
      @update="$emit('update')"
    />
  </div>
</template>

<script>
  import dayjs from 'dayjs';
  import draggable from 'vuedraggable';
  import Treeselect from '@riophae/vue-treeselect';
  import GroupedTable from '@/components/common/table/groupedTable.vue';
  import LogDetails from '@/components/common/table/log-details.vue';
  import { convertSecondsToDays } from '@/helpers/format-date';
  import AdditionalList from '@/components/common/logs/additional/list/index.vue';
  import { messengerName, directionName } from '@/components/pages/computers/log/messengers/filters';
  import { status } from '@/components/pages/computers/log/programs/utils';
  import { action as instProgAction } from '@/components/pages/computers/log/installed-programs/utils';
  import { action as filesAction } from '@/components/pages/computers/log/files/utils';
  import { type } from '@/components/pages/computers/log/web-mail/utils';
  import { type as clipboardType } from '@/components/pages/computers/log/clipboard/utils';
  import { logTypes } from '@/assets/scripts/dictionaries';
  import { MAP_LOG_TYPES } from '@/assets/scripts/mapTypes';
  import { getLogs } from '@/api/methods/computers';
  import { source, action, available } from '@/components/pages/computers/log/shadow-copyings/utils';
  import { driveType, action as drivesAction } from '@/components/pages/computers/log/external-drives/utils';

  import { action as netFilesAction } from '@/components/pages/computers/log/network-files/utils';
  import { action as hardwareAction } from '@/components/pages/computers/log/hardware-changes/utils';
  import ContextMenu from '@/components/common/contextmenu/notifications-menu.vue';
  import { getDataField } from '@/helpers/fields';
  import Loader from '@/components/common/blocks/loader.vue';
  import { groupFieldMap } from '@/views/notifications/const/const';

  export default {
    components: {
      draggable,
      GroupedTable,
      AdditionalList,
      Treeselect,
      ContextMenu,
      LogDetails,
      Loader,
    },
    props: [
      'isSearch',
      'tableData',
      'searchString',
      'emptyResultString',
      'columns',
      'isFiles',
      'isFilesSearch',
      'isFeed',
      'isPending',
      'isFetch',
      'isInfinitScroll',
      'selectedData',
      'tableName',
    ],
    data: () => ({
      targetId: null,
      isTargetChecked: true,
      isTargetEvent: false,
      dateRange: { dateFrom: new Date(), dateTo: new Date() },
      targetUser: null,
      targetEvent: null,
      targetTime: null,
      isMenuVisible: false,
      mouseX: null,
      mouseY: null,
      selectedLog: null,
      notGroupedColumns: [],
      selected: {},
      grouppedColumns: [],
      groupResult: [],
      isResultEmpty: false,
      selectedRow: null,
      foundSubstr: {},
      rowAdditionalData: null,
      logIdsMapping: {
        1: 1,
        2: 3,
        3: 4,
        4: 5,
        6: 7,
        7: 10,
        10: 14,
        11: 8,
        13: 15,
        17: 19,
        18: 23,
        19: 23,
        20: 22,
        21: 20,
        22: 21,
        23: 6,
        26: 25,
      },
    }),
    computed: {
      filteredData() {
        let result = this.tableData.slice(0);
        Object.entries(this.selected).forEach(([key, value]) => {
          if (value?.length) {
            result = result.filter((item) => value.indexOf(getDataField(item, key)) > -1);
          }
        });

        return result;
      },
      sortedData() {
        const calc = this.filteredData.slice(0).sort(this.compare);
        return calc;
      },
      sortedGroupData() {
        Object.keys(this.groupResult).forEach((key) => {
          this.sortNodes(this.groupResult[key]);
        });
        return this.groupResult;
      },
      additionalListNotifications() {
        if (this.rowAdditionalData) {
          const logTypeSlug = this.logIdsMapping[this.selectedRow.categoryId];
          return this.getAdditionalList(logTypeSlug, this.rowAdditionalData);
        }
        return [
          [this.$t('table.reason'), this.selectedRow.reasonString],
          [this.$t('table.content'), this.selectedRow.descriptionOutput],
        ];
      },
      selectedRowId() {
        if (this.selectedRow) return this.selectedRow.id;
        return null;
      },
      tableBodyRowClassFn() {
        return (item) => [
          this.dangerousClass(item),
          { [this.$style.active]: item?.id === this.selectedRow?.id },
          { [this.$style.red]: !this.isSearch && !item.checkUser && !this.isFeed && item.critLevel === undefined },
          this.$style.tr,
        ];
      },
      reorderedColumns() {
        const result = [];
        this.grouppedColumns.forEach((col) => result.push(col));
        if (result.length === 0) return this.columns;
        if (result.length < this.columns.length) {
          this.columns.forEach((column) => {
            const found = this.grouppedColumns.find((item) => item.field === column.field);
            if (!found) result.push(column);
          });
        }
        return result;
      },
    },
    watch: {
      selectedData: {
        handler(newVal) {
          if (newVal) {
            Object.keys(newVal).forEach((field) => {
              this.$set(this.selected, field, newVal[field]);
            });
          }
        },
        immediate: true,
      },

      grouppedColumns: {
        handler(newVal) {
          const currentView = this.$route.query.view || 'grid';

          const newView = newVal.length !== 0 ? 'groupped' : 'grid';

          if (currentView !== newView) {
            this.$router.push({
              query: {
                ...this.$route.query,
                view: newView,
              },
            });
          }
        },
        deep: true,
      },
      tableData(newArray, oldArray) {
        if (oldArray !== newArray) {
          this.selectedRow = null;
          if (newArray.length) this.isResultEmpty = false;
          else this.isResultEmpty = true;

          this.notGroupedColumns = this.columns.slice();

          if (this.grouppedColumns.length) this.group();
          else if (this.isFilesSearch) {
            const userColumn = this.columns.find((column) => column.field === 'username');
            const typeColumn = this.columns.find((column) => column.field === 'histtype_name');
            this.grouppedColumns.push(userColumn);
            this.grouppedColumns.push(typeColumn);
            this.group();
          }
        }
      },
    },
    methods: {
      scrollToRow(row) {
        this.$nextTick(() => {
          const refKey = `${this.tableName}-${row.id}`;

          const currentRef = this.$refs[refKey];
          const el = Array.isArray(currentRef) ? currentRef[0] : currentRef;
          if (!el) return;

          const container = this.$refs.virtualList;

          const { offsetTop } = el;

          container.scrollTo({
            top: offsetTop,
            behavior: 'smooth',
          });

          this.selectedRow = row;
        });
      },
      dangerousClass(item) {
        if (!item?.critLevel) return null;
        switch (item.critLevel) {
          case 1:
            return this.$style.yellow;
          case 2:
            return this.$style.red;
          default:
            return null;
        }
      },
      handleScroll() {
        if (!this.isInfinitScroll) return;
        const el = this.$refs.virtualList.$el;
        const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 100;
        if (isAtBottom && !this.isPending) this.$emit('update');
      },

      getIcon(logId) {
        return logTypes[MAP_LOG_TYPES[logId]];
      },
      showMenu(event, item) {
        if (!this.isSearch && !this.isFeed) {
          if (item.checkTime && item.checkUser) {
            this.isTargetChecked = true;
            this.targetId = null;
          } else {
            this.isTargetChecked = false;
            this.targetId = item.id;
          }

          this.mouseX = event.clientX;
          this.mouseY = event.clientY;

          if (item.eventId && item.categoryId !== 28) {
            this.isTargetEvent = true;

            this.targetUser = item.compId;
            this.targetEvent = item.eventId;
            this.targetTime = item.eventTime;

            this.selectedLog = logTypes.find(({ id }) => id === this.logIdsMapping[item.categoryId]);
          } else {
            this.isTargetEvent = false;
          }

          this.isMenuVisible = true;

          window.addEventListener('click', (e) => {
            this.isMenuVisible = false;
            window.removeEventListener('click', e);
          });
        }
      },
      getAdditionalList(category, data) {
        let { compname } = data;
        if (!this.isSearch) compname = data.username;

        if (this.isFiles) return [[this.$t('table.fileContent'), data.content, 'content']];

        switch (category) {
          case 1:
            return [
              [this.$t('pages.columns.username'), compname, 'compname'],
              [this.$t('pages.columns.caption'), data.caption, 'caption'],
              [this.$t('pages.columns.path'), data.path, 'path'],
              [this.$t('pages.columns.text'), data.keys, 'keys'],
            ];
          case 2:
            return [
              [this.$t('pages.columns.username'), compname, 'compname'],
              [this.$t('pages.columns.caption'), data.caption, 'caption'],
              [this.$t('pages.columns.path'), data.path, 'path'],
            ];
          case 3:
            return [
              [this.$t('pages.columns.username'), compname, 'compname'],
              [this.$t('pages.columns.caption'), data.caption, 'caption'],
              [this.$t('pages.columns.path'), data.path, 'path'],
              [this.$t('pages.columns.category'), data.category, 'category'],
              [this.$t('pages.columns.program'), data.name, 'name'],
              [this.$t('pages.columns.action'), status(data.status), 'status'],
            ];
          case 4:
            return [
              [this.$t('pages.columns.username'), compname, 'compname'],
              [this.$t('pages.columns.action'), filesAction(data.action), 'action'],
              [this.$t('pages.columns.path'), data.path, 'path'],
              [this.$t('pages.columns.size'), data.size, 'size'],
              ['MD5', data.crc, 'crc'],
              // [this.$t('pages.columns.filename'), data.exeName, 'exeName'],
            ];
          case 5:
            return [
              [this.$t('pages.columns.username'), compname, 'compname'],
              [this.$t('pages.columns.caption'), data.caption, 'caption'],
              ...(data.type === 0 ? [[this.$t('pages.columns.clipboardContent'), data.text, 'text']] : []),
              [this.$t('pages.columns.dataType'), clipboardType(data.type), 'typeName'],
            ];
          case 6:
            return [
              [this.$t('pages.columns.username'), compname, 'compname'],
              [this.$t('pages.columns.printer'), data.printer, 'printer'],
              [this.$t('pages.columns.document'), data.document, 'document'],
              [this.$t('pages.columns.printedPages'), data.pagesPrinted, 'pagesPrinted'],
              [this.$t('pages.columns.copies'), data.copies, 'copies'],
              [this.$t('pages.columns.computer'), data.computer, 'computer'],
              [this.$t('pages.columns.cost'), data.cost, 'cost'],
            ];
          case 7:
            return [
              [this.$t('pages.columns.username'), compname, 'compname'],
              [this.$t('pages.columns.caption'), data.caption, 'caption'],
              [this.$t('pages.columns.action'), instProgAction(data.action, 'action')],
              [this.$t('pages.columns.path'), data.path, 'path'],
            ];
          case 8:
            return [
              [this.$t('pages.columns.action'), drivesAction(data.action)],
              [this.$t('pages.columns.diskLetter'), data.driveChar],
              [this.$t('pages.columns.diskLabel'), data.driveLabel],
              [this.$t('pages.columns.diskType'), driveType(data.driveType)],
              [this.$t('pages.columns.fileSystem'), data.filesystem],
              [this.$t('pages.columns.serialNumber'), data.serial],
              [this.$t('pages.columns.username'), compname],
            ];
          case 10:
            return [
              [this.$t('pages.columns.username'), compname, 'compname'],
              [this.$t('pages.columns.caption'), data.caption, 'caption'],
              [this.$t('pages.columns.category'), data.category, 'category'],
              [this.$t('pages.columns.link'), data.link, 'link'],
              [this.$t('pages.columns.timeSite'), convertSecondsToDays(data.duration), 'duration'],
            ];
          case 14:
            return [
              [this.$t('pages.columns.action'), action(data.action)],
              [this.$t('pages.columns.filename'), data.filename],
              [this.$t('pages.columns.filesize'), data.filesize],
              [this.$t('pages.columns.available'), available(data.available)],
              [this.$t('pages.columns.source'), source(data.source)],
              ['File MD5', data.crc],
              [this.$t('pages.columns.username'), compname],
            ];
          case 15:
            return [
              [this.$t('pages.columns.username'), compname, 'compname'],
              [this.$t('pages.columns.dateSend'), data.dateSend, 'dateSend'],
              [this.$t('pages.columns.subject'), data.subject, 'subject'],
              [this.$t('pages.columns.from'), data.from, 'from'],
              [this.$t('pages.columns.to'), data.to, 'to'],
              [this.$t('pages.columns.text'), data.text, 'text'],
            ];
          case 19:
            return [
              [this.$t('pages.columns.username'), compname],
              [this.$t('pages.columns.filename'), data.filepath],
              [this.$t('pages.columns.action'), netFilesAction(data.action)],
              [this.$t('pages.columns.accessRights'), data.fileaccess],
            ];
          case 20:
            return [
              [this.$t('pages.columns.username'), compname, 'compname'],
              [this.$t('pages.columns.dateSend'), data.dateSend, 'dateSend'],
              [this.$t('pages.columns.subject'), data.subject, 'subject'],
              [this.$t('pages.columns.from'), data.from, 'from'],
              [this.$t('pages.columns.to'), data.to, 'to'],
              [this.$t('pages.columns.text'), data.text, 'text'],
              [this.$t('pages.columns.messageType'), type(data.type, 'type')],
              [this.$t('pages.columns.mailServer'), data.server, 'server'],
            ];
          case 21:
            return [
              [this.$t('pages.columns.link'), data.url],
              [this.$t('pages.columns.server'), data.host],
              [this.$t('pages.columns.username'), compname],
            ];
          case 22:
            return [
              [this.$t('pages.columns.username'), compname, 'compname'],
              [this.$t('pages.columns.buddy'), data.buddy, 'buddy'],
              [this.$t('pages.columns.socialNetwork'), data.socialDomain, 'socialDomain'],
              [this.$t('pages.columns.text'), data.text, 'text'],
            ];
          case 23:
            return [
              [this.$t('pages.columns.username'), compname, 'compname'],
              [this.$t('pages.columns.messenger'), messengerName(data.messenger), 'messenger'],
              [this.$t('pages.columns.buddy'), data.interlocutor, 'interlocutor'],
              [this.$t('pages.columns.messageType'), directionName(data.direction), 'direction'],
              [this.$t('pages.columns.text'), data.text, 'text'],
              [this.$t('pages.columns.messengerName'), data.usernameMessenger, 'usernameMessenger'],
            ];
          case 25:
            return [
              [this.$t('pages.columns.action'), hardwareAction(data.action)],
              [this.$t('pages.columns.deviceType'), data.hardwareType],
              [this.$t('pages.columns.description'), data.description],
            ];
          case 26:
            return [
              [this.$t('pages.columns.username'), compname, 'compname'],
              [this.$t('pages.columns.searchEngine'), data.engine, 'engine'],
              [this.$t('pages.columns.queryText'), data.query, 'query'],
            ];
          default:
            return [[this.$t('pages.columns.username'), compname]];
        }
      },
      filterGroupedData() {
        if (this.grouppedColumns.length > 0) {
          this.group();
        }
      },
      normalizer(node) {
        return {
          id: node,
          label: node,
        };
      },
      sortNodes(data) {
        if (data.array && Array.isArray(data.array)) {
          data.array.sort(this.compare);
        } else {
          Object.keys(data).forEach((key) => {
            this.sortNodes(data[key]);
          });
        }
      },
      compare(a, b) {
        const index = this.columns.findIndex((x) => x.sort > 0);
        const key = this.columns[index].field;

        a = a[key];
        b = b[key];

        if (typeof a === 'string' && typeof b === 'string') {
          a = a.toLowerCase();
          b = b.toLowerCase();
        }

        if (this.columns[index].sort === 1) {
          if (a > b) {
            return -1;
          }

          if (a < b) {
            return 1;
          }
          return 0;
        }

        if (this.columns[index].sort === 2) {
          if (a < b) {
            return -1;
          }

          if (a > b) {
            return 1;
          }

          return 0;
        }
        return 0;
      },
      getIndicesOf(searchStr, str) {
        const searchStrLen = searchStr.length;
        if (searchStrLen === 0) {
          return [];
        }
        let startIndex = 0;
        let index;
        const indices = [];

        // eslint-disable-next-line
        while ((index = str.indexOf(searchStr, startIndex)) > -1) {
          indices.push(index);
          startIndex = index + searchStrLen;
        }
        return indices;
      },
      async selectRow(row) {
        if (this.isSearch) {
          if (!this.isFilesSearch) {
            this.selectedRow = null;
            const found = {};

            // eslint-disable-next-line
            for (const [key, value] of Object.entries(row)) {
              if (typeof value === 'string') {
                const indices = this.getIndicesOf(this.searchString.toLowerCase(), value.toLowerCase());

                if (indices.length > 0) {
                  found[key] = indices;
                }
              }
            }

            this.foundSubstr = found;
          }
        } else if (!this.isInfinitScroll) {
          this.rowAdditionalData = null;
          if (row.eventId && row.categoryId !== 28) {
            const logTypeSlug = this.logIdsMapping[row.categoryId];
            if (logTypeSlug) {
              const log = logTypes.find((logItem) => logItem.id === logTypeSlug);
              this.promise = await getLogs(0, log.slug, row.eventId, '', '').then((data) => {
                this.rowAdditionalData = data[0];
              });
            }
          }
        }

        this.selectedRow = row;
      },
      getDataField(item, field) {
        return getDataField(item, field);
      },

      openLogs(item) {
        if (this.isSearch && !this.isFilesSearch) {
          const targetLog = logTypes.find((log) => log.id === item.logId);
          const routeData = this.$router.resolve({
            name: 'computers-computer-log-record',
            params: {
              computer: item.compId,
              log: targetLog.slug,
              record: item.id,
            },
            query: {
              dateFrom: dayjs(item.date).format('YYYY-MM-DD'),
              dateTo: dayjs(item.date).format('YYYY-MM-DD'),
            },
          });
          window.open(routeData.href, '_blank');
        }
      },
      move(evt) {
        let dragged = null;
        if (evt.added) dragged = evt.added.element.field;
        if (evt.moved) dragged = evt.moved.element.field;

        this.group();

        const indexOfObject = this.notGroupedColumns.findIndex((object) => object.field === dragged);

        if (indexOfObject > -1) this.notGroupedColumns.splice(indexOfObject, 1);
      },
      onMove(evt) {
        if (evt.from.nodeName === 'TR') {
          const exists = this.grouppedColumns.find((col) => col.field === evt.draggedContext.element.field);
          if (exists) return false;
          return true;
        }
        return true;
      },
      removeAt(idx) {
        const column = this.grouppedColumns[idx];
        this.grouppedColumns.splice(idx, 1);
        this.notGroupedColumns.push(column);
        if (this.grouppedColumns.length > 0) this.group();
      },
      groupRecursive(grouppedResult, columns) {
        if (columns.length > 0) {
          // eslint-disable-next-line
          for (const key of Object.keys(grouppedResult)) {
            if (grouppedResult[key].array && Array.isArray(grouppedResult[key].array)) {
              const groupObj = {};
              let groupField = columns[0].field;
              groupField = groupFieldMap[groupField] ?? groupField;
              for (let i = 0; i < grouppedResult[key].array.length; i++) {
                const fieldValue = grouppedResult[key].array[i][groupField];

                if (!groupObj[fieldValue]) {
                  groupObj[fieldValue] = {
                    expanded: true,
                    array: [grouppedResult[key].array[i]],
                  };
                } else {
                  groupObj[fieldValue].array.push(grouppedResult[key].array[i]);
                }
              }
              groupObj.expanded = grouppedResult[key].expanded;
              grouppedResult[key] = groupObj;
            }

            this.groupRecursive(grouppedResult[key], columns.slice(1));
          }
        }
      },
      group() {
        const data = this.sortedData;
        let groupField = this.grouppedColumns[0].field;
        groupField = groupFieldMap[groupField] ?? groupField;

        const grouppedResult = {};

        data.forEach((item) => {
          const key = item[groupField];

          if (!grouppedResult[key]) {
            grouppedResult[key] = {
              expanded: true,
              array: [item],
            };
          } else {
            grouppedResult[key].array.push(item);
          }
        });

        this.groupRecursive(grouppedResult, this.grouppedColumns.slice(1));
        this.groupResult = grouppedResult;
      },
    },
  };
</script>

<style lang="scss" module>
  .new {
    display: inline-block;
    background: $light-blue;
    color: $blue;
    font-size: 7px;
    padding: 3px;
    margin-right: 8px;
    border-radius: 1px;
  }

  .searchResultContainer {
    display: flex;
    margin: 10px;
    border: 1px solid #c4c4c4;
    overflow: auto;
    height: 60%;
    flex-direction: column;
    overflow-x: hidden;
  }

  .notificationsResult {
    height: 100%;
  }
  .feedResult {
    height: 78% !important;
  }

  .emptyResult {
    margin: 30px;
    display: flex;
    justify-content: center;
  }

  .table {
    word-break: break-word;
    overflow: auto;
    padding: 10px;
    border-collapse: collapse;
    position: sticky;
    z-index: 20;
    top: 50px;
    background: white;
    height: 30px;
    font-weight: 500;
    cursor: pointer;
    margin: 5px;
  }

  .td {
    padding: 5px;
    letter-spacing: -0.08px;
    font-size: 13px;
    border-bottom: 1px solid $borderColor;
    height: 30px;
    max-width: 500px;
    word-break: break-word;
  }

  .textCentr {
    text-align: center;
  }
  .draggableInput {
    display: flex;
    position: sticky;
    top: 0;
    z-index: 10;
    background: white;
    padding: 10px;
  }

  .grouppedItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    margin: 5px;
    border: 1px solid $borderColor;
    font-size: 13px;
    cursor: grab;
  }

  .btnClose {
    position: relative;
    top: 0;
    right: 0px;
    border: none;
    font-size: 18px;
    cursor: pointer;
    font-weight: bold;
    background: transparent;
    margin: 10px;
  }

  .grouppedColumnName {
    margin-left: 10%;
  }

  .groupHint {
    padding: 10px;
    font-size: 13px;
    color: #9a99a2;
    position: sticky;
    top: 0;
    z-index: 5;
    background: white;
    line-height: 30px;
  }

  .tr {
    cursor: pointer;

    &:hover {
      background: $light-gray;
    }

    &.active {
      background: $light-gray;
    }

    &.red {
      background-color: #ffb0b0;

      &:hover {
        background-color: $red;
      }

      &.active {
        background: $red;
      }
      &.yellow {
        background-color: #ffd977;

        &:hover {
          background-color: $yellow;
        }

        &.active {
          background: $yellow;
        }
      }
      &.yellow {
        background-color: #ffd977;

        &:hover {
          background-color: $yellow;
        }

        &.active {
          background: $yellow;
        }
      }
      &.yellow {
        background-color: #ffd977;

        &:hover {
          background-color: $yellow;
        }

        &.active {
          background: $yellow;
        }
      }
    }
  }

  .resultTable {
    margin: 10px;
  }

  .tdInline {
    display: inline-flex;
  }

  .arrow {
    margin-top: 7px;
    margin: 0px 5px;

    &.asc {
      transform: rotate(180deg);
    }

    &.hidden {
      visibility: hidden;
    }
  }

  .icon {
    display: inline-flex;
    margin-right: 10px;
    width: 15px;
  }
  .logIcon {
    display: inline-flex;
    width: 20px;
  }

  .loader {
    height: 500px;
  }
  .allData {
    padding: 0 0 10px 10px;
    font-size: 13px;
    color: #9a99a2;
    line-height: 30px;
  }
</style>

<style>
  .sortable-ghost {
    border: 1px dashed grey;
    font-size: 0;
    overflow: hidden;
    margin: 5px;
  }

  .dropdown .vue-treeselect__control {
    display: none !important;
  }

  .dropdown .vue-treeselect__menu-container {
    width: 300px !important;
  }

  #columnFilterkeywords .vue-treeselect__menu {
    left: -300px;
  }
</style>
